// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { getCodeStyles } from '@atlaskit/code/inline';
export const codeMarkSharedStyles = () => {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
      '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
      ...getCodeStyles()
    }
  });
};